module.exports = __webpack_public_path__ + "img/ebay_logo@2x.ae756d5d.png";